import { NavLink, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase/firebase";

export default function Login() {

    const navigate = useNavigate();

    async function login(formData) {
        await signInWithEmailAndPassword(auth, formData.get("userEmail"), formData.get("userPassword"))
            .then((userCredential) => {
                navigate("/post")
            })
            .catch(error => {
                console.log(error.message)
            })
    }

    function resetPassword() {
        var _email = window.prompt("Bitte gib Deine E-Mail-Adresse ein:", "E-Mail");
        sendPasswordResetEmail(auth, _email).then(() => {
            window.alert("Ein E-Mail zum Zurücksetzen des Passwortes wurde an " + _email + " geschickt.");
        });
    }

    return (
        <div className="page-class">
            <h1>Anmelden</h1>
            <form action={login}>
                <div className="mb-3">
                    <label htmlFor="userEmail" className="form-label">E-Mail</label>
                    <input type="email" required name="userEmail" className="form-control" />
                </div>
                <div className="mb-3">
                    <label htmlFor="userPassword" className="form-label">Passwort</label>
                    <input type="password" required name="userPassword" className="form-control" />
                </div>
                <button type="submit" className="btn btn-primary mb-5">Anmelden</button>
            </form>
            
            <p>Das erste Mal hier? Dann: <NavLink to="/signup" className="link-offset-3">Neu&nbsp;registrieren</NavLink></p>
            <br /><br />
            <NavLink to="" className="link-offset-3" onClick={resetPassword}>Passwort vergessen?</NavLink>
        </div>
    )
}